import React from 'react';
import { Box, IconButton } from '@material-ui/core';
import hamburgerIcon from 'assets/icons/hambuger.svg';
import QMASLogo from 'assets/img/qmas_logo.png';
import classes from './Sidebar.module.scss';

const SideBar = ({ children, isShowHeader }) => {
  return (
    <div className={classes.sidebar}>
      {isShowHeader && (
        <Box display='flex' flexDirection='row' alignItems='center'>
          <IconButton>
            <img src={hamburgerIcon} alt='hamburger' />
          </IconButton>
          <img src={QMASLogo} alt='logo' className={classes.logo} />
        </Box>
      )}

      <Box className={classes.content}>{children}</Box>
    </div>
  );
};
export default SideBar;
